import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Sidebar.css';

function Sidebar() {
  const { isAuthenticated, user, logout } = useAuth();
  const location = useLocation();

  const isActive = (path) => {
    return location.pathname === path ? 'nav-link active' : 'nav-link';
  };

  return (
    <aside className="sidebar">
      <div className="sidebar-content">
        <div className="sidebar-header">
          <img src="/tabnext_icon.png" alt="Tableau Next" className="sidebar-logo" />
          <h1 className="sidebar-title">Tableau Next Tools</h1>
        </div>

        <nav className="sidebar-nav">
          <Link to="/" className={isActive('/')}>
            🏠 Home
          </Link>
          <Link to="/package-deploy" className={isActive('/package-deploy')}>
            🚀 Package & Deploy
          </Link>
          <Link to="/documentation" className={isActive('/documentation')}>
            📖 Documentation
          </Link>
          <Link to="/support" className={isActive('/support')}>
            💬 Support
          </Link>
        </nav>

        {isAuthenticated && user && (
          <div className="sidebar-footer">
            <hr className="sidebar-divider" />
            <h2 className="sidebar-section-title">Authentication</h2>
            <div className="auth-info">
              <div className="alert-success-sidebar">
                You are logged in!
              </div>
              <div className="user-details">
                <div className="user-detail-item">
                  <strong>User:</strong>
                  <code>{user.name}</code>
                </div>
                <div className="user-detail-item">
                  <strong>Instance URL:</strong>
                  <code className="url-code">{user.instanceUrl}</code>
                </div>
                <div className="user-detail-item">
                  <strong>Org ID:</strong>
                  <code>{user.orgId}</code>
                </div>
              </div>
              <button className="button-logout" onClick={logout}>
                Logout
              </button>
            </div>
          </div>
        )}
      </div>
    </aside>
  );
}

export default Sidebar;

